<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">系统管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 用户管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn url="manager/company/export/exportCompanUserListPageByCompanyId" :params="seefrom" method="post"></downloadBtn>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="用户名">
                <el-input placeholder="请输入用户名" v-model="seefrom.name"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input placeholder="请输入手机号" v-model="seefrom.phone"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="manager/company/getCompanUserListPageByCompanyId"
            :parent="self"
            :config="config"
            :other="other"
            ref="user"
          >
            <template slot="last">
              <el-table-column label="操作" width="300" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.$index, scope.row)"
                  >编辑</el-link>
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="用户名" prop="username">
              <el-input v-model.trim="addEquipment.username"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile_phone">
              <el-input v-model.trim="addEquipment.mobile_phone"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="telephone">
              <el-input v-model.trim="addEquipment.telephone"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址" prop="postbox">
              <el-input v-model.trim="addEquipment.postbox"></el-input>
            </el-form-item>
            <el-form-item label="用户组" prop="value5">
              <el-checkbox-group class="checkbox-usergroup" v-model="value5">
                <el-checkbox v-for="item in groups" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="seeBtn">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      isAdmin: 0,
      loading: true,
      title: "",
      tabName: "jsgl",
      form_jsgl: {},
      editDialogVisible: false,
      showTable: true,
      seeBtn: true,
      other: {
        companyId: localStorage.getItem("companyId")
      },
      items: [],
      status: [
        { value: "0", label: "正常" },
        { value: "1", label: "冻结" }
      ],
      displayForm: false,
      value5: [],
      // value6: [],
      groups: [],
      seefrom: {
        name: "",
        phone: ""
      },
      addEquipment: {
        username: "",
        password: "",
        salt: "",
        telephone: "",
        mobile_phone: "",
        province_name: "",
        city_name: "",
        area_name: "",
        address: "",
        create_time: "",
        modify_time: "",
        province_id: "",
        city_id: "",
        area_id: "",
        last_login: "",
        selectedOptions: [],
        postbox: "",
        company: "",
        type_time: "",
      },
      //校验
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: 'blur' }
        ],
        mobile_phone: [
          { required: true, message: "请输入电话号码", trigger: 'blur' },
          {
            validator: function(rule, value, callback) {
              if (!/^[1]\d{10}$/.test(value)) {
                callback(new Error("手机号格式错误"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        // postbox: [
        //   { required: true, message: "请输入邮箱", trigger: 'blur' },
        //   {
        //     validator: function(rule, value, callback) {
        //       if (
        //         /^\w{1,64}@[a-z0-9\-]{1,256}(\.[a-z]{2,6}){1,2}$/i.test(
        //           value
        //         ) == false
        //       ) {
        //         callback(new Error("邮箱格式错误"));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ]
      }
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "用户名"
        },
        {
          prop: "phone",
          label: "手机号"
        },
        {
          prop: "telephone",
          label: "电话"
        },
        {
          prop: "email",
          label: "邮箱地址"
        }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    downloadBtn:()=>import('public/download')
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.other.companyId = localStorage.getItem("companyId");
      this.$refs.user.pageToOne();
      this.$nextTick(this.$refs.user.getData);
    },
    //重置
    reset() {
      this.seefrom.name = "";
      this.seefrom.phone = "";
    },
    //新增
    addnew() {
      this.title = "新增用户";
      this.state = 1;
      this.displayForm = true;
      this.addEquipment = {
        username: "",
        password: "",
        salt: "",
        mobile_phone: "",
        telephone: "",
        province_name: "",
        city_name: "",
        area_name: "",
        address: "",
        create_time: "",
        modify_time: "",
        province_id: "",
        city_id: "",
        area_id: "",
        last_login: "",
        selectedOptions: [],
        postbox: "",
        company: "",
        type_time: "",};
      this.value5 = [];
      this.seeBtn = true;
      this.$nextTick(() => {
          this.$refs["addEquipment"].clearValidate();
        })
    },
    //编辑
    edit(index, row) {
      //console.log(row,"rowe")
      this.title = "编辑用户信息";
      this.displayForm = true;
      this.seeBtn = true;
      this.value5 = [];
      this.$axiosget("operation/findGroup", {
        params: {
          id: row.id
        }
      }).then(res => {
        if (res.data.status === "10000") {
          this.state = 2;
          this.id = row.id;
          res.data.data.userGroups.forEach(item => {
            this.value5.push(item.group_id);
          });
        }
      });
      this.isAdmin = row.isAdmin;
      this.addEquipment.username = row.name;
      this.addEquipment.mobile_phone = row.phone;
      this.addEquipment.telephone = row.telephone;
      this.addEquipment.postbox = row.email;
      //console.log(this.addEquipment.username, this.addEquipment.mobile_phone, this.addEquipment.postbox)
      if (this.$refs["addEquipment"]) {
        this.$nextTick(() => {
          this.$refs["addEquipment"].clearValidate();
        })
      }
    },
    //确认
    submitAdd() {
      this.$refs.addEquipment.validate(valid => {
        if (valid) {
          // var nameList = [];
          let num = this.value5.join();
          if (this.state === 1) {
            // this.$axiosget(
            //   "manager/company/getCompanUserListPageByCompanyId"
            // ).then(Respone => {
            //   //console.log(Respone.data.data.list, "所有用户");
            // });
            this.$axiospost("manager/company/addOrUpdateCompanyUser", {
              status: 1,
              isAdmin: 0,
              name: this.addEquipment.username,
              telephone: this.addEquipment.telephone,
              phone: this.addEquipment.mobile_phone,
              email: this.addEquipment.postbox,
              companyId: localStorage.getItem("companyId")
            }).then(res => {
              if (res.data.status === 10009) {
                this.$message.warning("手机号已存在！");
              } else if (res.data.status === 10000) {
                this.$axiospost("operation/group/userGroup", {
                  list: num,
                  user_id: res.data.data.id
                }).then(res => {
                  if (res.data.status === "10000") {
                    this.displayForm = false;
                    this.subSeefrom();
                    let loading = Loading.service({});
                    loading.close();
                    this.$message.success("添加成功！");
                  }
                });
              }
            });
          } else if (this.state === 2) {
            //console.log(2);
            this.$axiospost("manager/company/addOrUpdateCompanyUser", {
              status: 1,
              id: this.id,
              isAdmin: this.isAdmin,
              name: this.addEquipment.username,
              telephone: this.addEquipment.telephone,
              phone: this.addEquipment.mobile_phone,
              email: this.addEquipment.postbox
            }).then(res => {
              if (res.data.status === 11) {
                this.$message.error(res.data.message);
              }
              if (res.data.status === 10000) {
                this.$axiospost("operation/group/userGroup", {
                  list: num,
                  user_id: res.data.data.id
                }).then(res => {
                  if (res.data.status === "10000") {
                    this.displayForm = false;
                    this.subSeefrom();
                    this.$message.success("编辑成功！");
                  }
                });
              }
            });
          }
        } else {
          this.$message.error("保存失败，请输入必填项！");
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("是否删除该用户?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiospost("manager/company/addOrUpdateCompanyUser", {
          id: row.id,
          status: 0
        }).then(res => {
          if (res.data.status === 10000) {
            this.subSeefrom();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      }).catch(()=>{

      })
    }
  },
  created() {
    this.$axiosget("operation/group/findAllList").then(res => {
      //console.log(res);
      if (true) {
        this.groups = res.data.data;
      }
    });
    // this.$axiosget("company/findAllCompany", {}).then(res => {

    //   if (res.data.status === "10000") {
    //     this.value6 = res.data.data;
    //   }
    // });
  }
};
</script>

<style scoped lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
.checkbox-usergroup {
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/user/index.vue